
import { AlertCircle } from "lucide-react"
import { Alert, AlertDescription } from "@/components/ui/alert"

interface FormHintProps {
  step: number
}

export function FormHint({ step }: FormHintProps) {
  const hints = {
    1: "Please provide your contact information. This will be used to send you updates about your letter.",
    2: "The recipient will not be notified until the official cease and desist letter is sent. Their information is kept confidential and secure.",
    3: "Describe the situation that led to this cease and desist letter. Be specific but concise.",
    4: "Choose your preferred delivery method and complete the payment.",
    5: "Review and customize your letter before sending."
  }

  return (
    <Alert className="mb-6 bg-blue-50 border-blue-200">
      <AlertCircle className="h-4 w-4 text-blue-600" />
      <AlertDescription className="text-blue-700">
        {hints[step as keyof typeof hints]}
      </AlertDescription>
    </Alert>
  )
}
